// import React from 'react'
import { connect } from 'react-redux'
import { Debug } from 'components/debug'

import type { FormModel } from './ModelFormField'

type ModelDebugOwnProps = {
  model: FormModel
  pk: unknown
}

const ModelDebug = connect((state, { model, pk }: ModelDebugOwnProps) =>
  model.getItem(pk)(state),
)(Debug)
export default ModelDebug
